'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Search = undefined;

var _Search2 = require('./Search');

var _Search3 = _interopRequireDefault(_Search2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Search = _Search3.default;


//////////////////
// WEBPACK FOOTER
// ./src/containers/Search/index.js
// module id = 1847
// module chunks = 0